export default __webpack_public_path__ + "static/media/whatsapp.c0b1fabc.svg";